import axiosInstance from "../lib/axiosInstance"

/**
 * Makes an API call to the Experience service using the specified endpoint, method, and request options.
 * JWT auth is handled by axiosInstance interceptor.
 *
 * @param {string} endpoint - The API endpoint (e.g., '/api/example-endpoint').
 * @param {string} method - The HTTP method ('GET', 'POST', etc.).
 * @param {Object} [params={}] - URL query parameters.
 * @param {Object} [data={}] - Request body (for POST/PUT).
 * @param {Object} [headers={}] - Additional headers.
 * @returns {Promise<Object>} API response or error object.
 */
export async function makeExperienceApiCall(
  endpoint,
  method,
  params = {},
  data = {},
  headers = {},
) {
  try {
    return await axiosInstance({
      method,
      url: endpoint,
      params,
      data,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    })
  } catch (error) {
    return {
      data: { error: error.message || "API request failed" },
      status: error.response?.status || 500,
    }
  }
}

/**
 * Formats a date string into MM-DD-YYYY format.
 */
export const formatToMMDDYYYY = (dateString) => {
  if (!dateString) return ""

  const date = new Date(dateString)
  // ✅ Use Number.isNaN instead of isNaN
  if (Number.isNaN(date.getTime())) return ""

  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  const year = date.getFullYear()

  return `${month}-${day}-${year}`
}
